import React from "react";
import { HelpOutline } from "@material-ui/icons";
import { Row, Col, Button, Dropdown, Modal } from "react-bootstrap";
import { MoreVert, Close } from "@material-ui/icons";
import folderIcon from "./../../assets/img/folder.svg";
import tickIcon from "./../../assets/img/tickIcon.png";
import crossIcon from "./../../assets/img/crossIcon.png";
import moment from "moment";
import noRecord from "./../../assets/img/no-record.png";
import UrlConstants from "../../config/UrlConstants";
import {
  archiveDocAction,
  updateDocAction,
  getFolderListAction,
  moveDocAction,
  addDocAction,
  removeDocumentAction,
} from "./../../actions/DocActions";
import {
  updateTaskAction,
  getTaskDetailsAction,
} from "./../../actions/TransactionActions";
import { connect } from "react-redux";
import { cryptoTokenDecode, toastMessage } from "./../Common/Common";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";

var _ = require("lodash");

class DocumentsDetail extends React.Component {
  constructor(props) {
    let userType = cryptoTokenDecode().usertype;

    let currentType = cryptoTokenDecode().roleName;

    super(props);
    this.state = {
      showArchieve: false,
      show: false,
      showPreview: false,
      previewURL: "",
      docName: "",
      userRole: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      showMove: false,
      folderList: "",
      docId: "",
      showNewFolder: false,
      folderExists: false,
      folderName: "",
      error: "",
      lastFolder: "",
      showArchiveModal: false,
      archiveDoc: {},
      showDeleteModal: false,
      fromArchive: false,
    };
  }

  showArchieve() {
    this.setState({ showArchieve: !this.state.showArchieve });
  }

  setModalOpen() {
    this.setState({ show: !this.state.show });
  }
  setFolderModalClose() {
    this.setState({
      showMove: !this.state.showMove,
      error: "",
      showNewFolder: false,
      folderName: "",
      lastFolder: "",
    });
    this.props.archiveDocument("add");
  }
  /**
   * @desc Get document content by api call and show it in modal
   * @param {*} name
   * @param {*} transactionId
   */
  ModalPreview(name, transactionId) {
    if (name) {
      var url = "/#";
      fetch(
        UrlConstants.AdminCreateTransactionUrl +
          "/" +
          name +
          "?id=" +
          transactionId,
        { method: "GET" }
      )
        .then((response) => response.json())
        .then((res) => {
          url = res.url;
          this.setState({
            showPreview: !this.state.showPreview,
            previewURL: url,
            docName: name,
          });
        });
    }
  }
  /**
   * @desc get type of doc file
   * @param {*} name
   */
  getType(name) {
    var type = "";
    if (name) {
      var ext = ((name.match(/(\.\w+$)/gim) || [])[0] + "").toLowerCase();
      if (ext == ".jpg" || ext == ".jpeg" || ext == ".png" || ext == ".gif") {
        type = "image";
      } else if (name.match(/.(pdf)$/i)) {
        type = "pdf";
      }
    }
    return type;
  }

  /**
   * @desc api call for archive document
   * @param {*} doc
   */
  archiveDocument(doc) {
    this.props.archiveDocAction(doc._id).then((res) => {
      this.setState({ showArchiveModal: false });
      this.props.archiveDocument("archive");
    });
  }
  /**
   * @desc api call for remove document
   */
  removeDocument() {
    this.props.removeDocumentAction(this.state.docId).then((res) => {
      this.setState({ showDeleteModal: false });
      if (this.state.fromArchive) {
        this.props.archiveDocument("fromArchive");
      } else {
        this.props.archiveDocument("add");
      }
    });
  }
  /**
   * @desc api call for get folder list
   */
  getFolderList() {
    this.props
      .getFolderListAction(this.props.transactionId, this.props.folderName)
      .then((folderList) => {
        if (this.state.lastFolder != "") {
          if (folderList.includes(this.state.lastFolder)) {
            var index = folderList.indexOf(this.state.lastFolder);
            folderList.splice(index, 1);
            folderList.sort();
            folderList.unshift(this.state.lastFolder);
            this.setState({ folderList });
          }
        } else {
          folderList.sort();
          this.setState({ folderList });
        }
      });
  }
  /**
   * @desc api call for move document
   * @param {*} location
   */
  moveDocument(location, isRestore, docId) {
    if (location != "") {
      var data = {
        location: location,
      };
      this.props.moveDocAction(data, this.state.docId).then((res) => {
        if (res.status === code.OK) {
          toastMessage(code.SUCCESS, message.DOCUMENT_MOVED);
          this.setFolderModalClose();
          this.props.archiveDocument("add");
        } else {
          toastMessage(code.ERROR, res.data);
        }
      });
    } else {
      var data = {
        isRestore: isRestore,
      };
      this.props.moveDocAction(data, docId).then((res) => {
        if (res.status === code.OK) {
          toastMessage(code.SUCCESS, message.DOCUMENT_RESTORED);
          this.props.archiveDocument("add");
        } else {
          toastMessage(code.ERROR, res.data);
        }
      });
    }
  }

  createNewFolder(name) {
    name = (name + "").trim();
    this.setState({ folderExists: false });

    var dataToPost = {
      transactionId: this.props.transactionId,
      location: name,
      document: [],
    };
    this.props.addDocAction(dataToPost).then((res) => {
      if (res && res.status === code.CONFLICT) {
        toastMessage(code.ERROR, res.data);
        this.setState({ folderExists: true });
      } else {
        this.setState({
          folderExists: false,
          showNewFolder: false,
          lastFolder: name,
        });
        this.getFolderList();
      }
    });
    this.setState({ folderName: "" });
  }

  render() {
    // let isActive = localStorage.getItem("isActive");
    var files = [];
    var { folderName, transactionId, documents } = this.props;
    documents = _.sortBy(documents, "document");
    var docURL = UrlConstants.downloadDocUrl.replace(
      "{transactionId}",
      transactionId
    );
    return (
      <React.Fragment>
        <Row className="mx-0 align-items-center folder-detail-title">
          <Col className="col-auto pr-0">
            <img
              src={folderIcon}
              alt="folder"
              style={{ width: "30px", height: "30px" }}
            />
          </Col>
          <Col>
            <h4 className="color-black font-18 mb-0">{folderName}</h4>
          </Col>
          <Col align="right" className="col-auto">
            {this.props.transactionData.status === "COMPLETED" ||
            !this.props.canAddDoc ? (
              ""
            ) : (
              <div
                variant="primary"
                size="xs"
                hidden={this.props.hideNewDocument}
                className="btn-outlined btn-blue-light h-auto font-14 browse-btn btn"
              >
                <input
                  type="file"
                  id="browseDoc"
                  multiple
                  value={files}
                  accept=".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.jpg,.png,.gif,.jpeg"
                  onChange={(e) => {
                    // if (isActive === "false") {
                    //   toastMessage(
                    //     code.ERROR,
                    //     "Your subscription is not active, Please activate to continue."
                    //   );
                    // } else {
                    //   this.props.uploadNewDocument(e.target.files);
                    //   files = [];
                    // }
                    this.props.uploadNewDocument(e.target.files);
                    files = [];
                  }}
                />

                <label htmlFor="browseDoc">+ New Document</label>
              </div>
            )}
          </Col>
        </Row>
        <div className="folder-detail">
          {documents.map((doc, i) => {
            return (
              <Row key={"doc" + i} className="mx-0 folder-detail-row">
                {this.getType(doc.document) == "image" ||
                this.getType(doc.document) == "pdf" ? (
                  <Col
                    className="pl-2"
                    onClick={() =>
                      this.ModalPreview(doc.uploadedFileName, transactionId)
                    }
                  >
                    <div className="custom-control custom-checkbox font-15 color-black font-500 mr-0 pl-0">
                      <label className="mb-0">{doc.document}</label>
                    </div>
                    <p className="color-grey-1 font-14 mb-0">
                      Updated {moment(doc.modifiedDate).format("MM/DD/YYYY")}
                    </p>
                  </Col>
                ) : (
                  <Col className="pl-2">
                    <div className="custom-control custom-checkbox font-15 color-black font-500 mr-0 pl-0">
                      <label className="mb-0">
                        <a
                          href={
                            docURL.replace("{documentId}", doc._id) +
                            doc.uploadedFileName
                          }
                          download
                        >
                          {doc.document}
                        </a>
                      </label>
                    </div>
                    <p className="color-grey-1 font-14 mb-0">
                      Updated {moment(doc.modifiedDate).format("MM/DD/YYYY")}
                    </p>
                  </Col>
                )}
                <Col className="col-auto">
                  <Dropdown alignRight className="dropdown-action">
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="p-0"
                    >
                      <MoreVert />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        href={
                          docURL.replace("{documentId}", doc._id) +
                          doc.uploadedFileName
                        }
                        download
                      >
                        Download
                      </Dropdown.Item>
                      {(this.getType(doc.document) == "image" ||
                        this.getType(doc.document) == "pdf") && (
                        <Dropdown.Item
                          onClick={() =>
                            this.ModalPreview(
                              doc.uploadedFileName,
                              transactionId
                            )
                          }
                        >
                          Preview
                        </Dropdown.Item>
                      )}
                      {this.props.transactionData.status != "COMPLETED" && (
                        <>
                          {this.props.canArchive &&
                            doc.isArchive == false &&
                            !doc.isDelete && (
                              <Dropdown.Item
                                className="color-dark-orange-3"
                                onClick={() => {
                                  this.setState({
                                    showArchiveModal: true,
                                    archiveDoc: doc,
                                  });
                                }}
                              >
                                Archive document
                              </Dropdown.Item>
                            )}
                        </>
                      )}
                      {doc.isDelete || doc.isArchive ? (
                        <Dropdown.Item
                          onClick={() => {
                            this.moveDocument("", true, doc._id);
                          }}
                        >
                          Restore
                        </Dropdown.Item>
                      ) : (
                        ""
                      )}

                      {this.props.canMove && !doc.isDelete && !doc.isArchive && (
                        <Dropdown.Item
                          onClick={() => {
                            // if (isActive === "false") {
                            //   toastMessage(
                            //     code.ERROR,
                            //     "Your subscription is not active, Please activate to continue."
                            //   );
                            // } else {
                            //   this.setState({ showMove: true, docId: doc._id });
                            //   this.getFolderList();
                            // }

                            this.setState({ showMove: true, docId: doc._id });
                            this.getFolderList();
                          }}
                        >
                          Move
                        </Dropdown.Item>
                      )}
                      {this.state.userRole === message.ACCTOWNER ? (
                        <Dropdown.Item
                          onClick={() => {
                            // if (isActive === "false") {
                            //   toastMessage(
                            //     code.ERROR,
                            //     "Your subscription is not active, Please activate to continue."
                            //   );
                            // } else {
                            //   this.setState({
                            //     showDeleteModal: true,
                            //     docId: doc._id,
                            //     fromArchive: doc.isDelete,
                            //   });
                            // }

                            this.setState({
                              showDeleteModal: true,
                              docId: doc._id,
                              fromArchive: doc.isDelete,
                            });
                          }}
                        >
                          Delete
                        </Dropdown.Item>
                      ) : (
                        ""
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>
            );
          })}
          {documents.length <= 0 && (
            <div className="no-transaction no-record">
              <div className="no-transaction-inner">
                <img src={noRecord} alt="no record" />
                <p>No Documents</p>
              </div>
            </div>
          )}
        </div>

        <Modal
          show={this.state.showPreview}
          onHide={() => {
            this.setState({
              showPreview: false,
            });
          }}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-preview"
        >
          <Modal.Header className="d-block">
            <Row className="align-items-center">
              <Col xs="9">
                <div className="modal-title">Document Preview</div>
              </Col>
              <Col xs="3" className="text-right">
                <Button
                  className="close-btn"
                  variant="transparent"
                  onClick={() => {
                    this.setState({
                      showPreview: false,
                    });
                  }}
                >
                  <Close />
                </Button>
              </Col>
            </Row>
          </Modal.Header>
          <Modal.Body>
            {this.getType(this.state.docName || "") == "image" ? (
              <img
                src={
                  UrlConstants.AdminCreateTransactionUrl +
                  "/upload?id=" +
                  transactionId +
                  "&img=" +
                  this.state.docName
                }
              />
            ) : (
              <object
                data={this.state.previewURL || "#"}
                width="100%"
                height="100%"
              />
            )}
          </Modal.Body>
        </Modal>
        {/* 
                Move Document Modal */}
        <Modal
          show={this.state.showMove}
          onHide={() => this.setFolderModalClose()}
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-document-upload"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Folder</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="folder-list folder">
              {this.state.folderList.length !== 0 ? (
                this.state.folderList.map((folder) => {
                  return (
                    <Row
                      className={"mx-0 align-items-center folder-single"}
                      onClick={() => {
                        this.moveDocument(folder);
                      }}
                    >
                      <Col className="col-auto pr-0">
                        <img
                          src={folderIcon}
                          alt="folder"
                          style={{ width: "30px", height: "30px" }}
                        />
                      </Col>
                      <Col>
                        <h4 className="color-black font-16 mb-0">{folder}</h4>
                      </Col>
                    </Row>
                  );
                })
              ) : (
                <Row className={"mx-0 align-items-center folder-single"}>
                  <Col>
                    <h4 className="color-black font-16 mb-0">
                      No Folders Found
                    </h4>
                  </Col>
                </Row>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.state.showNewFolder ? (
              <div className="new-folder-wrapper">
                <input
                  name="title"
                  type="text"
                  className={"task-add-input form-control field_ucfirst"}
                  placeholder="Enter folder name"
                  value={this.state.folderName}
                  onChange={(e) => {
                    this.setState({
                      folderName: e.target.value,
                      folderExists: false,
                      error: "",
                    });
                  }}
                />

                <Button
                  variant="primary"
                  size="sm"
                  className="btn-blue submit_name"
                  style={{ margin: "0 2px 0 0" }}
                  onClick={() => {
                    if (this.state.folderName === "") {
                      this.setState({ error: "Please enter folder name" });
                    } else {
                      this.createNewFolder(this.state.folderName);
                    }
                  }}
                >
                  <img src={tickIcon} alt="folder" />
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  className="btn-blue discard_name"
                  onClick={() => {
                    this.setState({
                      showNewFolder: false,
                      error: "",
                      folderName: "",
                    });
                  }}
                >
                  <img src={crossIcon} alt="folder" />
                </Button>
              </div>
            ) : (
              (this.state.userRole !== message.BUYER &&
                this.state.currentRole === message.ACCTOWNER) ||
              (this.state.userRole === message.VENDOR &&
                this.state.currentRole === message.Artist && (
                  <Button
                    type="submit"
                    variant="primary"
                    size="sm"
                    disabled={false}
                    className="btn-blue w-140"
                    onClick={() => {
                      this.setState({ showNewFolder: true });
                    }}
                  >
                    + New Folder
                  </Button>
                ))
            )}
            {this.state.error !== "" ? (
              <span style={{ color: "red" }}>{this.state.error}</span>
            ) : (
              ""
            )}
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showArchiveModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Are you sure you want to archive document?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.setState({ showArchiveModal: false, archiveDoc: {} });
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.archiveDocument(this.state.archiveDoc);
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showDeleteModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Are you sure you want to delete a document?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.setState({ showDeleteModal: false, archiveDoc: {} });
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.removeDocument();
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    docs: state.reducer.docs || [],
  };
};

export default connect(
  mapStateToProps,
  {
    archiveDocAction,
    updateDocAction,
    updateTaskAction,
    getTaskDetailsAction,
    getFolderListAction,
    moveDocAction,
    addDocAction,
    removeDocumentAction,
  }
)(DocumentsDetail);
